import React from 'react';

import { PlayType, PlayTypeNameEnum } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { Toggle } from 'src/components/Toggle';
import { ContractTermSection } from 'src/components/shared/ContractTermSection';

import './ViewPlayType.scss';

interface IViewPlayTypeProps {
    playTypes?: PlayType[];
}

export const ViewPlayType = ({ playTypes }: IViewPlayTypeProps) => {
    const hasPlayTypes = !!playTypes && playTypes.length > 0;
    const onDemandPlayTypeDef = playTypes?.find((playType) => playType.playTypeName === PlayTypeNameEnum.ON_DEMAND)
        ?.playTypeDefinitions?.[0]?.description;

    const hasPlayType = (playTypeName: string) => {
        if (!hasPlayTypes) return false;
        return !!playTypes.find((playType) => playType.playTypeName === playTypeName);
    };

    return (
        <ContractTermSection title={'Play type'}>
            <Toggle
                label="Enable different rates per play type (On-Demand, Shuffle, Station, etc.)"
                value={hasPlayTypes}
                isEditMode={false}
            />
            {hasPlayTypes && (
                <Column spacing="300">
                    <Text type="h300">Play types selected</Text>
                    <Toggle label="On-Demand" value={hasPlayType(PlayTypeNameEnum.ON_DEMAND)} isEditMode={false} />
                    <Toggle label="Shuffle" value={hasPlayType(PlayTypeNameEnum.SHUFFLE)} isEditMode={false} />
                    <Toggle label="Station" value={hasPlayType(PlayTypeNameEnum.STATION)} isEditMode={false} />
                </Column>
            )}
            {onDemandPlayTypeDef && (
                <Column spacing="300">
                    <Text type="h300">On-Demand playlist calculation</Text>
                    <Toggle label={onDemandPlayTypeDef} value={true} isEditMode={false} />
                </Column>
            )}
        </ContractTermSection>
    );
};
